import React from "react";

import { Creatives } from "reducers/Creatives";
import FilterHeader from "utils/columns/FilterHeader";
import { safeDecodeURIComponent } from "utils/common";


export  function FileName({ value }){
	const displayValue = safeDecodeURIComponent(value);

	return(
		<div className="creative-filename-col">
			<span title={displayValue} className="name-overflow">{displayValue}</span>
		</div>
	);
}

const FileNameCell = {
	key: "filename",
	name: "File Name",
	filter:"String",
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = {state => state.creatives.columnFilters.active.filename}
		/>
	),
	formatter:FileName,
	width:110,
	sortable:true,
	resizable:true,
};

export default FileNameCell;
